import { render, staticRenderFns } from "./proTag.vue?vue&type=template&id=1ece9a96&scoped=true&"
import script from "./proTag.vue?vue&type=script&lang=js&"
export * from "./proTag.vue?vue&type=script&lang=js&"
import style0 from "./proTag.vue?vue&type=style&index=0&id=1ece9a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece9a96",
  null
  
)

export default component.exports